import $http from '../../shared/http';

export default {
  namespaced: true,
  state: () => {
    return {
      financialPeriodsForSelect: [],
    };
  },
  getters: {
    getFinancialPeriodsForSelect: (state) => state.financialPeriodsForSelect,
  },
  mutations: {
    setFinancialPeriodsForSelect: (state, payload) => (state.financialPeriodsForSelect = payload),
  },
  actions: {
    async LOAD_FINANCIAL_PERIOD(_, id) {
      return $http()
        .get(`financial-periods/${id}`)
        .then((response) => {
          return response.data.data;
        });
    },
    async LOAD_FINANCIAL_PERIODS_FOR_SELECT({ commit }, { churchId }) {
      return $http('v2')
        .get(`organisations/${churchId}/financial_periods/select`, { canBeImpersonated: true })
        .then((response) => {
          commit('setFinancialPeriodsForSelect', response.data.data);
          return response;
        });
    },
  },
};
